export default "__VITE_ASSET__C8s_NLRI__"